import { render, staticRenderFns } from "./ArticleTable.vue?vue&type=template&id=415bc298&scoped=true&"
import script from "./ArticleTable.vue?vue&type=script&lang=js&"
export * from "./ArticleTable.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTable.vue?vue&type=style&index=0&id=415bc298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415bc298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VDataTable,VHover,VIcon,VTooltip})
